const SalesRegionMap = new Map();

SalesRegionMap.set(1200, "Central");
SalesRegionMap.set(100, "Florida");
SalesRegionMap.set(400, "Mid-Atlantic");
SalesRegionMap.set(600, "Midwest");
SalesRegionMap.set(500, "New England");
SalesRegionMap.set(1500, "New York");
SalesRegionMap.set(700, "North Central");
SalesRegionMap.set(1300, "Northern California");
SalesRegionMap.set(1100, "Pacific Northwest");
SalesRegionMap.set(200, "South");
SalesRegionMap.set(800, "South Central");
// SalesRegionMap.set(1000, "Southern California"); // June 2023: SoCal has been absorbed by Southwest.
SalesRegionMap.set(900, "Southwest");
SalesRegionMap.set(1400, "Tri-State");
// SalesRegionMap.set(300, "Virginia"); // June 2023: Virginia has been absorbed by the Mid-Atlantic and South regions.
SalesRegionMap.set(0, "Unassigned");

export default SalesRegionMap;
